import {
    apiRequest,
    admindiklatTrainingList,
    admindiklatUpdate,
    admindiklatDetail
} from "../../../../../../../services/adapters/kepegawaian/diklatService"

class UpdateRepository {

    fetchTrainingList = async (query, cancelToken) => {
        return await apiRequest("get", admindiklatTrainingList, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", admindiklatUpdate, {
            body: query
        }, true)
    }
    
    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", admindiklatDetail, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

}

export default UpdateRepository